import type { ReactNode, JSX } from 'react';
import { SharedRegistrationCustomizationsProvider } from './SharedRegistrationCustomizationsProvider';

type Props = {
  children: JSX.Element | ReactNode | ReactNode[];
  eventHashedId: string;
};

export const AnonymousRegistrationCustomizationsProvider = ({
  children,
  eventHashedId,
}: Props): JSX.Element => {
  return (
    <SharedRegistrationCustomizationsProvider
      eventHashedId={eventHashedId}
      isInEditorMode={false}
    >
      {children}
    </SharedRegistrationCustomizationsProvider>
  );
};
